// LIBRERIE/IMPORTS
import React from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface ServicesSectionProps {
  showServices: boolean;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ showServices }) => {
  const { t } = useTranslation();

  if (!showServices) return null;

  const servicesLinkTitle = t('navigation.servicesLinkTitle');
  const searchLinkTitle = t('navigation.searchLinkTitle');
  const contactButtonText = t('homePage.agencyInfoSnippet.contactButton');

  return (
    <section className="space-ptb bg-green" id="service-box">
      <div className="container">
        <h2 className="text-center mb-4">{t('homePage.servicesSection.title')}</h2>
        <div className="row justify-content-center align-items-stretch">
          {/* Link Servizi */}
          <div className="col-12 col-sm-10 col-lg-6 mb-3">
            <Link to="/servizi" title={servicesLinkTitle ?? ''} className="service">
              <i>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </i>
              {t('homePage.servicesSection.servicesDescription')}
            </Link>
          </div>

          {/* Link Partner */}
          <div className="col-12 col-sm-10 col-lg-6 mb-3">
            <Link to="/cerca" title={searchLinkTitle ?? ''} className="service">
              <i>
                <FontAwesomeIcon icon={faLocationDot} />
              </i>
              {t('homePage.servicesSection.partnerDescription')}
            </Link>
          </div>

        </div>
        <div className="row">

          {/* Colonna Destra: Info Agenzia */}
          <div className="col-12">
            <div className="p-3 text-center col-dx">
              <h3 className="mb-3">{t('homePage.presentation.presentationTitle')}</h3>
              <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.agencyInfoSnippet.text') as string }}></p>
              {/* Bottone Contatti */}
              <Link to="/contatti" title={contactButtonText ?? ''} className="btn btn-primary text-uppercase">
                {contactButtonText}
              </Link>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;